import { createFileRoute } from '@tanstack/react-router'
import { WargaLifeEventsPage } from './life-events.page'

export const Route = createFileRoute('/desa/$slug/warga/life-events')({
  component: WargaLifeEventsPage,
})
